var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vote" }, [
    _c(
      "div",
      { staticClass: "question" },
      [
        _c("h2", { staticClass: "normal" }, [_vm._v("问答管理")]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("主题："),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.tag_name,
                expression: "tag_name"
              }
            ],
            attrs: { rows: "5", cols: "50" },
            domProps: { value: _vm.tag_name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.tag_name = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.evaluateScore,
              expression: "evaluateScore"
            }
          ],
          attrs: { type: "number" },
          domProps: { value: _vm.evaluateScore },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.evaluateScore = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "file", id: "evaluate" },
          on: { change: _vm.chooseImage }
        }),
        _vm._v(" "),
        _vm._l(_vm.evaluate, function(item, key) {
          return _c("div", { key: key, staticClass: "image-box" }, [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    return _vm.delEvaluateKey(key)
                  }
                }
              },
              [_vm._v(_vm._s(key))]
            ),
            _vm._v(" "),
            _c("img", { attrs: { src: item, alt: "" } })
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "line" }, [
          _vm._v("--------------横幅图--------------")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _c("input", {
            attrs: { type: "file", id: "ad_image" },
            on: { change: _vm.chooseImage }
          })
        ]),
        _vm._v(" "),
        _vm.ad_image.length > 0
          ? _c("div", { staticClass: "imageBoxMini" }, [
              _c("img", {
                attrs: {
                  src: _vm.ad_image,
                  preview: "5",
                  "preview-text": "横幅图"
                }
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.delAdImage } }, [_vm._v("删除")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "line" }, [
          _vm._v("--------------海报图--------------")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _c("input", {
            attrs: { type: "file", id: "poster_image" },
            on: { change: _vm.chooseImage }
          })
        ]),
        _vm._v(" "),
        _vm.poster_image.length > 0
          ? _c("div", { staticClass: "imageBoxMini" }, [
              _c("img", {
                attrs: {
                  src: _vm.poster_image,
                  preview: "6",
                  "preview-text": "海报图"
                }
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.delPosterImage } }, [
                _vm._v("删除")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "center" }, [
          _c("button", { staticClass: "up", on: { click: _vm.updateTheme } }, [
            _vm._v("新增主题")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("题目："),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.title,
                expression: "title"
              }
            ],
            attrs: { rows: "5", cols: "50" },
            domProps: { value: _vm.title },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.title = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal" }, [
          _vm._v("类型：\n      "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.type,
                  expression: "type"
                }
              ],
              attrs: { name: "", id: "" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "单选" } }, [_vm._v("单选")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "多选" } }, [_vm._v("多选")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "normal1" }, [
          _c("button", { on: { click: _vm.addOption } }, [_vm._v("增加选项")])
        ]),
        _vm._v(" "),
        _vm._l(_vm.options, function(option, index) {
          return _c("div", { key: index, staticClass: "options" }, [
            _c("div", { staticClass: "normal" }, [
              _c(
                "span",
                {
                  style: { color: _vm.answer[index] ? "yellow" : "black" },
                  on: {
                    click: function($event) {
                      return _vm.setAnswer(index)
                    }
                  }
                },
                [_vm._v("选项" + _vm._s(index + 1) + "：")]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options[index].words,
                    expression: "options[index].words"
                  }
                ],
                attrs: { rows: "5", cols: "50" },
                domProps: { value: _vm.options[index].words },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.options[index], "words", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c("input", {
                attrs: { type: "file", id: "optionImage" + index },
                on: { change: _vm.chooseImage }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.delOption(index)
                    }
                  }
                },
                [_vm._v("删除选项")]
              )
            ]),
            _vm._v(" "),
            _c("img", { attrs: { src: _vm.options[index].image, alt: "" } })
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "center" }, [
          _vm.currentTheme.id
            ? _c("div", [_vm._v("主题：" + _vm._s(_vm.currentTheme.tag_name))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "up", on: { click: _vm.updateQuestion } },
            [_vm._v("上传问题")]
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "data" },
        _vm._l(_vm.questionList, function(item, index) {
          return _c(
            "div",
            {
              key: item.id,
              class: {
                "data-item-cur": _vm.questionListCurrent.indexOf(index) > -1,
                "data-item": true
              },
              on: {
                click: function($event) {
                  return _vm.onQuestionItemClick(index)
                }
              }
            },
            [
              _vm._v(
                _vm._s(index + 1) + "." + _vm._s(item.interact_content.title)
              )
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.searchText },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchText = $event.target.value
              },
              _vm.onTitleInput
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data" },
        _vm._l(_vm.searchList, function(item, index) {
          return _c(
            "div",
            {
              key: item.id,
              class: {
                "data-item-cur": _vm.searchListCurrent.indexOf(index) > -1,
                "data-item": true
              },
              on: {
                click: function($event) {
                  return _vm.onSearchItemClick(index)
                }
              }
            },
            [_vm._v(_vm._s(item.tag_name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c(
          "div",
          { staticClass: "control-item", on: { click: _vm.toSeeQuestion } },
          [_vm._v("看问题")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control-item", on: { click: _vm.toAddQuestion } },
          [_vm._v("添问题")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control-item", on: { click: _vm.toBeVoting } },
          [_vm._v("去问答")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "data" },
        _vm._l(_vm.votingList, function(item, index) {
          return _c(
            "div",
            {
              key: item.id,
              class: {
                "data-item-cur": _vm.votingListCurrent.indexOf(index) > -1,
                "data-item": true
              },
              on: {
                click: function($event) {
                  return _vm.onVotingItemClick(index)
                }
              }
            },
            [_vm._v(_vm._s(index + 1) + "." + _vm._s(item.tag_name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c(
          "div",
          {
            staticClass: "control-item",
            staticStyle: { "background-color": "red" },
            on: { click: _vm.updateVotingList }
          },
          [_vm._v("更新")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "control-item", on: { click: _vm.del } }, [
          _vm._v("删除")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control-item", on: { click: _vm.toBeVoted } },
          [_vm._v("结束问答")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d7cf55d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7cf55d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/question.vue
// module id = null
// module chunks = 